import { getStaticCDN } from '@design-system/utils/utils';

export const VISIT_US_CONTENT = {
  title: 'sellCar.visitUs.title',
  subtitle: 'sellCar.visitUs.subtitle',
  locations: [
    {
      name: 'sellCar.visitUs.locations.soka.name',
      address: 'sellCar.visitUs.locations.soka.address',
      image: getStaticCDN('/assets/shared/sell-car/visit-us/jp/visit-us-soka.jpg'),
      gmapLink: 'https://maps.app.goo.gl/6tRMRtLBRs9GYU777?g_st=com.google.maps.preview.copy',
    },
    {
      name: 'sellCar.visitUs.locations.mito.name',
      address: 'sellCar.visitUs.locations.mito.address',
      image: getStaticCDN('/assets/shared/sell-car/visit-us/jp/visit-us-mito.jpg'),
      gmapLink: 'https://maps.app.goo.gl/VbrLHHHvCjL24LbB7?g_st=com.google.maps.preview.copy',
    },
  ],
};
